import { TextField } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { type ChangeEvent } from "react";

interface SimpleInputProps {
  fieldId: string;
}

const SimpleInput = (props: SimpleInputProps) => {
  const findFieldById = useFormData((fd) => fd.findFieldById);

  const field = findFieldById(props.fieldId);
  const value = field.value.asString();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.setValue(e.target.value);
  };

  const customName = field.id();
  const writable = field.writable;

  const { translatorFor } = useFormDataContext();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);
  const help = translateField(translator, field, Suffix.HELP);

  const errorMessage =
    field.violations().length > 0
      ? field.violations().at(0)?.translate(translator)
      : undefined;

  return (
    <TextField
      type='text'
      errorText={errorMessage || ""}
      helperText={field.hasHelper() ? help.toString() : ""}
      isError={Boolean(errorMessage)}
      required={Boolean(field.required)}
      label={label.toString()}
      value={value.hasBeenSet() ? value.value() : value.defaultValue()}
      onChange={onChange}
      disabled={!writable}
      key={field.id()}
      dataTestId={`ledgers-order__textfield-${customName}`}
    />
  );
};

export default SimpleInput;
